import React, { useCallback, useMemo, useState } from 'react';
import { AuthLinkComponent } from '../components';
export function useCommon(defaultInput, linkText, descp, signinOrRegisterLink) {
    const [inputs, setInputs] = useState(defaultInput);
    const handleInputChange = useCallback((event) => {
        event.persist();
        setInputs(Object.assign(Object.assign({}, inputs), { [event.target.getAttribute('id')]: event.target.value }));
    }, [inputs]);
    const LinkComponent = useMemo(() => (React.createElement(AuthLinkComponent, { link: signinOrRegisterLink, text: linkText, descp: descp, styleClass: "account" })), [signinOrRegisterLink, linkText, descp]);
    return {
        handleInputChange,
        LinkComponent,
        inputs,
    };
}
//# sourceMappingURL=useCommon.js.map